import React, { useEffect, useState, useRef } from "react";
import "./stylessh.css";
import { saf } from "../../../json/saf";


const Saf = () => {
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Subsecretaría de Administración y Finanzas</h1>
          </div>
          <div className="containerimg">
                <img width="300"  src={"../../../contenido/transparencia/saf/img/saflogo.png"}/>  
                                   
                </div>
               <h6>EN CUMPLIMIENTO A LA LEY GENERAL DE CONTABILIDAD GUBERNAMENTAL, TITULO QUINTO DE LA TRANSPARENCIA Y DIFUSIÓN DE LA INFORMACIÓN FINANCIERA, CAPITULO I, ARTICULO 56 Y 58</h6> 
                <div className="containerimg">
                <img width="500"  src={"../../../contenido/transparencia/saf/imag.jpg"}/>  
                                   
                </div>
        </div>
      </div>
    
       <div className="steps-row">
       {saf.map((item, index) => (
          <div key={index} className="col-12 seccion">
            <h1 className="titulo-seccion"></h1>
            <div className="bloque">
            <h5 className="mt-3 titulo-bloque">{item.titulo_item_nombre}</h5>
              {item.img_url!==undefined ? (<div className="container">
                  <img width="450"  src={item.img_url}/>                                     
                </div>) : ''
              }
              
            <div className="cuerpo-bloque">
                {item.archivos.map((tram, i) => (
                  <div>
                  {" "}
                 
                  <a className={tram.extencion}
                    target="{_blank}"
                    key={i}
                    href={tram.file_item_url}
                  >
                    {tram.file_item_nombre}
                  </a>{" "}
                </div>
                ))}
              </div>
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Saf;
